import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DataService } from './data.service';
import { ActivatedRoute } from '@angular/router';
import { SentryService } from './sentry.service';

@Injectable({
  providedIn: 'root'
})
export class LeadifulService {
  email : string = '';
  constructor(private http: HttpClient,
    private sentryService:SentryService,
    private dataService : DataService, private route?: ActivatedRoute) {
      this.dataService.getCurrentSite().subscribe(site=>{
        if(site){
          this.email = site.email;
        }
      })
  }
  public postLead(campaign :string, access_token: string, customFieds: object): Observable<object> {
     try {
        const formData = new FormData();
        formData.append("campaign",campaign);
        for (const [key, value] of Object.entries(customFieds)) {
          formData.append(key,value);
        }
        if (this.route.snapshot.queryParams.utm_source || this.route.snapshot.queryParams.utm_campaign || this.route.snapshot.queryParams.utm_medium ) {
            formData.append("utm_source",this.route.snapshot.queryParams.utm_source);
            formData.append("utm_campaign",this.route.snapshot.queryParams.utm_campaign);
            formData.append("utm_medium",this.route.snapshot.queryParams.utm_medium);
        }
        // http://localhost:4201/?utm_source=achraf_source&utm_campaign=achraf_campaign&utm_medium=achraf_medium
        let baseUrl = environment.leadifulUrl;
        if(this.email && this.email == environment.emailKia){
          baseUrl = environment.leadifulKiaUrl;
        }
        (!environment.production)?console.log('email :',this.email):null;
        (!environment.production)?console.log('baseUrl :',baseUrl):null;
        return this.http.post(`${baseUrl}/index.php/api/leads`,
        formData,
        { headers:
          { Anonymous: 'Anonymous',
            "SECRET-TOKEN" : access_token ,
            "Cache-Control" : "*/*" ,
            "Accept" : "no-cache" ,
            "cache-control" : "no-cache" ,
          } });
     } catch (error) {
        this.sentryService.errorHandling(error,'leads-service',error.error.message?error.error.message:(error.message?error.message:error));
     }
  }
}
